export const erc721Addr = "0xd2f6c67DBf7254b24688B88336998Be8Bf9dAbb9";
